import { Character } from "../types";
import { api } from "./base.api";

export const charactersAPI = {
  createCharacter: async (character: Partial<Character>) => {
    const response = await api.post("/characters", character);
    return response.data;
  },

  getCharacters: async (page: number = 1, limit: number = 5) => {
    const response = await api.get<{
      characters: Character[];
      pagination: {
        total: number;
        page: number;
        limit: number;
        pages: number;
      };
    }>(`/characters?page=${page}&limit=${limit}`);
    return response.data;
  },

  getCharacter: async (id: string) => {
    const response = await api.get<Character>(`/characters/${id}`);
    return response.data;
  },

  updateCharacter: async (id: string, character: Partial<Character>) => {
    console.log({ character });
    const response = await api.patch<Character>(`/characters/${id}`, character);
    return response.data;
  },

  deleteCharacter: async (id: string) => {
    const response = await api.delete(`/characters/${id}`);
    return response.data;
  },
};
